(function () {
  // Auto-tag h2 and p inside .product__description so they animate individually
  document.querySelectorAll('.product__description h2, .product__description p').forEach(function (el) {
    el.classList.add('js-fadein');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  document.querySelectorAll('.js-fadein').forEach(function (el) {
    observer.observe(el);
  });
})();
